import { render, staticRenderFns } from "./getRedis.vue?vue&type=template&id=c2431c72&scoped=true"
import script from "./getRedis.vue?vue&type=script&lang=js"
export * from "./getRedis.vue?vue&type=script&lang=js"
import style0 from "./getRedis.vue?vue&type=style&index=0&id=c2431c72&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2431c72",
  null
  
)

export default component.exports